import { elementController } from '@public-pages/runtime-core';

elementController('main-section', ({ query }) => {
  const showMoreButton = query('.main-section__button');
  const showLessButton = query('.two-cards__button');
  const buttonContainer = query('.main-section__button-holder');
  const content = query('.main-section__content');

  showMoreButton?.addEventListener('click', () => {
    dispatchEvent(new CustomEvent('render-slider'));
    buttonContainer?.classList.add('main-section__button-holder--show');
    content?.classList.add('main-section__content--show');
  });

  showLessButton?.addEventListener('click', () => {
    buttonContainer?.classList.remove('main-section__button-holder--show');
    content?.classList.remove('main-section__content--show');
  });
});
